import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "../assets/css/introduction.css";

const Introduction = () => {
  return (
    <section className="intro-section py-5" id="introduction">
      <Container>
        <Row className="align-items-center gx-5">
          {/* Text Content */}
          <Col lg={6} className="mb-4 mb-lg-0">
            <div className="intro-content pe-lg-4">
              <span className="subtitle">Experts in Climate Control</span>
              <h2 className="title mb-4">Welcome to Breath Comfort Air Systems</h2>
              <p className="description mb-4">
                For over 15 years, we've been the trusted name in residential and commercial
                air conditioning solutions. Our certified technicians deliver exceptional
                service from installation to maintenance, ensuring your comfort in every season.
              </p>
              <div className="key-features mb-4">
                <div className="feature-item">
                  <i className="bi bi-check-circle-fill"></i>
                  <span>24/7 Emergency Services</span>
                </div>
                <div className="feature-item">
                  <i className="bi bi-check-circle-fill"></i>
                  <span>Energy-Efficient Solutions</span>
                </div>
                <div className="feature-item">
                  <i className="bi bi-check-circle-fill"></i>
                  <span>Free Consultations</span>
                </div>
              </div>
              <div className="d-flex gap-3">
                <a
                  href={window.innerWidth <= 768 ? "tel:+97343434783" : "https://wa.me/97343434783"}
                  className="btn-consultation text-decoration-none text-white rounded-2"
                  style={{ backgroundColor: "#3c348d" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Schedule a Consultation
                </a>
                <a href="/services" className="btn-services text-decoration-none btn btn-outline-dark fw-medium" >Our Services</a>
              </div>
            </div>
          </Col>

          {/* Image and Cards Section */}
          <Col lg={6}>
            <div className="intro-visual position-relative">
              <div className="main-image-wrapper mb-4">
                <img
                  src="https://public.readdy.ai/ai/img_res/f329c8f48ea73a5fc90f9b548b55bed6.jpg"
                  className="img-fluid rounded"
                  alt="Professional Team"
                />
              </div>

              <Row className="stats-cards g-3">
                <Col sm={6}>
                  <Card className="stat-card text-center h-100">
                    <Card.Body>
                      <h3 className="stat-number">1500+</h3>
                      <p className="stat-label mb-0">Happy Clients</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col sm={6}>
                  <Card className="stat-card text-center h-100">
                    <Card.Body>
                      <h3 className="stat-number">98%</h3>
                      <p className="stat-label mb-0">Satisfaction Rate</p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Introduction;